import React, {useEffect, useState} from "react";
import BaseScreen from "../base/BaseScreen";
import { BasicGrid, SmallHeaderTitle, inter, primaryPink, } from "../../Theme";
import {ReactComponent as addIcon} from '../../resources/icons/plus.svg';
import styled from "styled-components";
import {device} from "../../constants/breakpoints";
import ExamOverviewCard from "./ExamOverviewCard";
import Api from "../../util/Api";
import AppStorage, {StorageKey} from "../../util/AppStorage";
import moment from "moment";
import {useHistory} from "react-router-dom";
import 'moment/locale/nl';
import {Loader} from "../../components/Loader";
import {isInReadOnlyMode} from "../../App";
import {showNativeNavigation} from "../../AppInterface";
import {useMenuDataContext} from '../../contexts/MenuDataContext';
import {checkRequiredFeatureFlags} from '../../util/Helpers';
import {FeatureFlags} from '../../constants/featureFlags';
import {FeaturePreview} from '../../components/FeaturePreview/FeaturePreview';
import { PageHeader } from "../../components/PageHeader/PageHeader";

function ExamOverviewScreen() {
    const {featureFlags} = useMenuDataContext();
    const canViewExamOverviewScreen = checkRequiredFeatureFlags(featureFlags, FeatureFlags.FEATURE_SCHEDULE);

    if (!canViewExamOverviewScreen) {
        return <FeaturePreview feature="examOverview" />
    }

    return (
        <ExamOverviewScreenComponent />
    );
}

function ExamOverviewScreenComponent() {
    const history = useHistory();
    const [exams, setExams] = useState([]);
    const [areExamsFetched, setExamsFetched] = useState(false);

    useEffect(() => {
        showNativeNavigation()
        Api.get(`pupils/${AppStorage.get(StorageKey.PUPIL_ID)}/exams`, (response) => {
            setExams(response.data)
            setExamsFetched(true);
        });
    }, []);

    const content = (
        <ExamOverViewRoot>

            {!areExamsFetched &&
                <Loader/>
            }

            <PageHeader>
                <PageHeader.Center>
                    <SmallHeaderTitle>Toetsweek</SmallHeaderTitle>
                </PageHeader.Center>
            </PageHeader>

            {areExamsFetched &&
            <ExamGridWrapper>
                <BasicGrid>
                    {exams.sort((a, b) => {return a.date - b.date}).map((exam) => {
                        return  <ExamOverviewCard
                                    key={exam.id}
                                    exam={exam}
                                />
                    })}

                    {!isInReadOnlyMode() && <AddExamButton onClick={createNewExam}>
                        <AddExamButtonTextWrapper>
                            <StyledAddIcon />
                            <AddExamButtonText>
                                Toets toevoegen
                            </AddExamButtonText>
                        </AddExamButtonTextWrapper>
                    </AddExamButton>}
                </BasicGrid>
            </ExamGridWrapper>
            }
        </ExamOverViewRoot>
    );

    return (
        <BaseScreen
            activeMenuItem={"Toetsweek"}
            content={content}
        />
    )

    function createNewExam() {
        history.push('/toets');
    }
}


export function getFormattedDateFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    let day = moment(date).format("dddd");
    return day.charAt(0).toUpperCase() + day.slice(1) + " " + moment(date).format("LL");
}


export const ExamOverViewRoot = styled.div`
    width: 100%;
    height: 100%;
    position: relative;  
`;

export const ExamGridWrapper = styled.div`
    margin: 0 auto;
    max-width: 1050px;
    padding: 40px;
    
    @media screen and ${device.laptop} {
        padding: 17px;
    }   
`;

export const AddExamButton = styled.a`
    position: relative;
    border-radius: 3px;
    border: 1px dashed rgba(227, 75, 148, 0.15);
    background: rgba(227, 75, 148, 0.05);
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 193px;
    
    &:hover {
        cursor: pointer;
    }
    
    @media screen and ${device.mobileL} {
        height: 57px;
    }   
`;

export const AddExamButtonTextWrapper = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
`;

export const AddExamButtonText = styled.span`
    font-family: ${inter};
    font-weight: 600;
    font-size: 14px;
    color: ${primaryPink};
`;

export const StyledAddIcon = styled(addIcon)`
    width: 20px;
    height: 20px;
    color: ${primaryPink};
`

export default ExamOverviewScreen;
